export class Router {
    constructor(routes, matchSubPaths = false) {
        this.matchSubPaths = false;
        this.routes = routes;
        this.matchSubPaths = matchSubPaths;
        this._loadInitialRoute();
    }
    _getCurrentURL() {
        const path = window.location.pathname;
        return path;
    }
    _matchUrlToRoute(dir) {
        for (let route of this.routes) {
            if (this.matchSubPaths) {
                if (dir.split('/')[0].split('?')[0] === route.path) {
                    return route;
                }
            }
            else if (route.path === decodeURIComponent(dir)) {
                return route;
            }
        }
        console.warn('No match for route:', dir);
        return null;
    }
    _loadInitialRoute() {
        let hash = window.location.hash;
        let [base, params] = hash.split('?');
        if (base.startsWith('#')) {
            this.loadRoute(base.slice(1));
        }
        else {
            this.loadRoute(this.routes[0].path);
        }
    }
    loadRoute(dir) {
        const matchedRoute = this._matchUrlToRoute(dir);
        if (!matchedRoute) {
            console.error('Route not found:', dir);
            return;
        }
        this.navigateTo(matchedRoute.path, dir);
        matchedRoute.callback();
    }
    navigateTo(path, dir) {
        let url = window.location.href;
        let [base, pathname] = url.split('#');
        if (path.length > 0) {
            if (this.matchSubPaths && dir !== path) {
                const newurl = `${base}#${dir}`;
                history.pushState({}, '', newurl);
            }
            else {
                const newurl = `${base}#${path}`;
                history.pushState({}, '', newurl);
            }
        }
        else {
            history.pushState({}, '', `${base}`);
        }
    }
}
export class Route {
}
